// eslint-disable-next-line
import React from "react";
//import tw from "twin.macro";
//import wave from "../../../icons/Wave.svg";
//import RegistrationForm from "./RegisrationForm";
import RegistrationForms from "./RegistrationForms";

const TrainingSection = () => {
  return (
    <>
      <div>
        <div tw="bg-gray-700 height[70px] w-full"> </div>
        <div
          tw="flex-col py-20 md:py-0 min-h-screen justify-center items-center  bg-no-repeat bg-cover  space-y-10 bg-gray-700 text-white p-5"
          
        >
          <center>
            <div>
              <h1 tw="text-4xl pt-4">Register Here</h1>
              <div tw="max-w-3xl py-12">
                {/* <RegistrationForm /> */}
                <RegistrationForms />
              </div>
            </div>
          </center>
        </div>
      </div>
    </>
  );
};

export default TrainingSection;
